import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import "../../css/Admin-Skills/AdminEditSkills.css";
import Spinner from "../Spinner";

const AdminEditSkills = ({ onClose, productData, fetchData, projectKey }) => {
  const [uploadSkillsLogo, setUploadSkillsLogo] = useState(0);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    ...productData,
    skillsName: productData?.skillsName,
    skillsPercentage: productData?.skillsPercentage,
    skillsLogo: productData?.skillsLogo || [],
  });

  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  async function handleUploadLogo(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.skillsName}-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Handle state changes such as progress, pause, and resume
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setUploadSkillsLogo(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          reject(error);
          setLoading(false);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              skillsLogo: [...prev.skillsLogo, downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  
  const handleDeleteLogo = (index) => {
    //console.log("clicl");
    const newLogos = [...data.skillsLogo];
    newLogos.splice(index, 1);
    setData((pre) => {
      return {
        ...pre,
        skillsLogo: [...newLogos],
      };
    });
  };


  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    //console.log(projectKey);
    const docRef = doc(db, "skills", projectKey);
    await updateDoc(docRef, data);
    setLoading(false);
    toast.success("Skill Updated");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Edit Skill</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="skillsName">Skill Name :</label>
          <input
            type="text"
            id="skillsName"
            placeholder="Enter Skill name"
            value={data.skillsName}
            name="skillsName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="skillsPercentage">Percentage:</label>
          <input
            type="number"
            id="skillsPercentage"
            placeholder="Enter Institute Name"
            value={data.skillsPercentage}
            name="skillsPercentage"
            onChange={handleOnChange}
            min={0}
            max={100}
            className="input"
            required
          />
          <label htmlFor="skillsLogo" className="label">
          Skill Logo :
          </label>
          <label htmlFor="skillsLogo">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Skills Logo</p>
                <input
                  type="file"
                  id="skillsLogo"
                  className="hidden"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>
          </label>
          {uploadSkillsLogo > 0 && uploadSkillsLogo < 100 && (
            <label
              style={{ color: "blue", textAlign: "center" }}
            >{`Upload is ${uploadSkillsLogo}% done`}</label>
          )}

          <div>
            {data.skillsLogo.length > 0 ? (
              <div className="image-preview">
                {data.skillsLogo.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteLogo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Skill Logo</p>
            )}
          </div>

         
          <button className="submit-button">Update Skill</button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};
    
export default AdminEditSkills;
